/**
 * Der Satz zum Ladefehler der Zustaendigkeitsmodule (Fehleranzeige Paket 2, Task 8, Regel L2).
 *
 * Die Module haben keine eigene Flaeche: bei einem Ladefehler bietet die Auswahl der Aufgabenbearbeitung nur
 * „Kein Modul" an. Das sagt ein Eintrag im Fehlerstapel - `meldeFehler(ursache, MODULE_LADEN_SATZ)`, danach die
 * Ursache. Der Aufgaben-Reiter (`TasksTab/TasksTab.tsx`) und der Sammelsendungs-Drawer (`SammelsendungDrawer.tsx`)
 * laden dieselben Module und melden denselben Satz: scheitert beides gleich, laufen die beiden Meldungen im Stapel
 * ueber den Zaehler zu EINEM Eintrag zusammen (Regel L5, „Texte gleich halten"). Deshalb steht der Satz an genau
 * einer Stelle und nicht als zwei Abschriften.
 *
 * Eigene, kleine Datei statt in `api/zustaendigkeitsModule.ts`: Tests ersetzen jenes Modul als Ganzes durch eine
 * Attrappe (`sammelsendungDrawer.test.tsx`), und die Konstante verschwaende dabei lautlos.
 */
export const MODULE_LADEN_SATZ =
  "Die Zuständigkeitsmodule konnten nicht geladen werden – die Auswahl bietet nur „Kein Modul“ an.";
